import { render } from "./CompletedTaskListItem.vue?vue&type=template&id=33ed27ad"
import script from "./CompletedTaskListItem.vue?vue&type=script&lang=js"
export * from "./CompletedTaskListItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__